/*
 * @Author: wangyueqi
 * @Date: 2024-11-01 17:12:03
 * @LastEditors: wangyueqi
 * @LastEditTime: 2024-11-14 15:10:53
 * @Description: 
 */
import http from '@/until/request'
import base  from './base'
let url =base.host+base.getAllUserList
// console.log(url,'base')
export default {
    getAllUserList(params){
      return http.get(base.host+base.getAllUserList,params)
    },
    getAgeDistribution( ){
      return http.post(base.host+base.getAgeDistribution)
    },
    getGenderRatio( ){
      return http.post(base.host+base.getGenderRatio)
    },
    getStatisticzl( ){
      return http.post(base.host+base.getStatisticzl)
    },
    getStatisticjz( ){
      return http.post(base.host+base.getStatisticjz)
    },
    getStatisticsh( ){
      return http.post(base.host+base.getStatisticsh)
    },
    getDailyNewUsers( ){
      return http.post(base.host+base.getDailyNewUsers)
    },
    AIChronicDiseasePrediction( ){
      return http.post(base.host+base.AIChronicDiseasePrediction)
    },
    //设备————————————————————————————————————————————————————
    getDevicesTypeProportion( ){
      return http.post(base.host+base.getDevicesTypeProportion)
    },
    getDailyBindUsers( ){
      return http.post(base.host+base.getDailyBindUsers)
    },
    getNumber( ){
      return http.post(base.host+base.getNumber)
    },
    getSostype( ){
      return http.post(base.host+base.getSostype)
    },
    SosList( ){
      return http.post(base.host+base.SosList)
    },
    getMapDataDetails( ){
      return http.get(base.host+base.getMapDataDetails)
    },
    getOneDateFromSos(params){
      return http.get(base.host+base.getOneDateFromSos,params)
    },
    updateSosHandleOnSosld(params){
      return http.get(base.host+base.updateSosHandleOnSosld,params)
    },
	getDevListByEid(params){
		return http.get(base.host+base.getDevListByEid,params)
	},
	login(data){
		return http.post(base.host+base.login,data)
	},
    getHomeServiceOrders(params){
        return http.get(base.host+base.getHomeServiceOrders,params)
    }
}
